"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createGetSlideAnimateState = void 0;
const createGetSliderState_1 = require("./createGetSliderState");
function createGetSlideAnimateState(count, width) {
    const getState = (0, createGetSliderState_1.createGetSliderState)(count, width);
    return (state, i, mx = 0) => {
        const { dir, baseX, isActive, isCurrentSlide, isPrevSlide } = getState(state, i);
        // invisible slides should not intersect viewport area
        // they should stay at their previous side
        const inertiaTo = (i - state.prev - dir) * width;
        const from = isCurrentSlide
            ? dir * width + mx
            : isPrevSlide
                ? mx
                : inertiaTo;
        const to = isPrevSlide ? -dir * width : isActive ? baseX : inertiaTo;
        return {
            isActive,
            from,
            to,
        };
    };
}
exports.createGetSlideAnimateState = createGetSlideAnimateState;
//# sourceMappingURL=createGetSlideAnimateState.js.map